import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { contactSettingsSelector } from 'redux/selectors/contactSettings.selector';
import { sendContactEmailRequest, resetContactStatus } from 'redux/actions/contactSettings.actions';

import LayoutContainer from 'containers/LayoutContainer';
import ContactView from 'views/public/ContactView';
import Loading from 'components/commons/Loading';

import { IContactFormData } from 'views/public/ContactView/types';
import 'views/public/ContactView/i18n';

const ContactContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { loading, success } = useTypedSelector(contactSettingsSelector);

  useEffect(() => {
    return () => {
      dispatch(resetContactStatus());
    };
  }, [dispatch]);

  const onSubmit = (formData: IContactFormData) => dispatch(sendContactEmailRequest(formData));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <ContactView onSubmit={onSubmit} success={success} />
      {loading && <Loading isModalMode message={i18next.t('CONTACT:LOADING')} />}
    </LayoutContainer>
  );
};

export default ContactContainer;
